module.exports = __webpack_public_path__ + "media/images/aloe/icons/new-cart-2fbfb7ac569a1fdbb970402139e6f5ca.svg";